import { WEATHER_DETAIL_ICON_KEYS } from 'features/Weather/config/weatherDetailIcons.config';
import { formatCurrentConditionMeasurement } from '../../../features/CurrentConditions/utils/currentConditions.utils';

export const currentConditionsDetails = [
  {
    id: 'humidity',
    label: 'Humidity',
    iconKey: WEATHER_DETAIL_ICON_KEYS.HUMIDITY,
    getValue: (condition) => formatCurrentConditionMeasurement(condition?.humidity, '%'),
  },
  {
    id: 'visibility',
    label: 'Visibility',
    iconKey: WEATHER_DETAIL_ICON_KEYS.VISIBILITY,
    getValue: (condition) => formatCurrentConditionMeasurement(condition?.visibility, ' mi'),
  },
  {
    id: 'comfort',
    label: 'Feels Like',
    iconKey: WEATHER_DETAIL_ICON_KEYS.COMFORT,
    getValue: (condition) => formatCurrentConditionMeasurement(condition?.comfort, '°F'),
  },
  {
    id: 'dewPoint',
    label: 'Dew Point',
    iconKey: WEATHER_DETAIL_ICON_KEYS.DEW_POINT,
    getValue: (condition) => formatCurrentConditionMeasurement(condition?.dew_point, '°F'),
  },
  {
    id: 'windSpeed',
    label: 'Wind Speed',
    iconKey: WEATHER_DETAIL_ICON_KEYS.WIND_SPEED,
    getValue: (condition) => formatCurrentConditionMeasurement(condition?.wind_speed, ' mph'),
  },
  {
    id: 'pressure',
    label: 'Pressure',
    iconKey: WEATHER_DETAIL_ICON_KEYS.PRESSURE,
    getValue: (condition) => formatCurrentConditionMeasurement(condition?.baro_pressure, ' inHg'),
  },
];

export const currentConditionsDetailGroups = [
  ['humidity', 'visibility'],
  ['comfort', 'dewPoint'],
  ['windSpeed', 'pressure'],
];
